import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-rc-decennale',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent, RouterModule],
  templateUrl: './assurance-rc-decennale.component.html',
  styleUrls: ['./assurance-rc-decennale.component.scss']
})
export class AssuranceRcDecennaleComponent {
  title = 'Assurance Responsabilité Civile Décennale';
  subtitle = '';
  phoneNumber = '01 42 27 12 43';
  heroImage = 'assets/static_pages_images/LES_RABOTEURS.jpg';
  
  breadcrumbs = [
    { label: 'Professionnels', link: undefined },
    { label: 'RC Décennale', link: undefined }
  ];

  prevPage = { 
    title: 'Assurance Responsabilité Civile Mandataires Sociaux',
    link: '/assurance-rc-mandataires-sociaux'
  };

  nextPage = { 
    title: 'Assurance Protection Juridique Pro',
    link: '/assurance-protection-juridique-pro'
  };

  constructor(private router: Router) {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }
}
